export default function GrowthChart({ members }) {
  const currentYear = new Date().getFullYear()
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

  const monthlyGrowth = months.map((month, index) => {
    const count = members.filter(m => {
      const date = new Date(m.joined_at)
      return date.getFullYear() === currentYear && date.getMonth() === index
    }).length
    return { month, count }
  })

  const maxValue = Math.max(...monthlyGrowth.map(m => m.count), 1)
  const totalThisYear = monthlyGrowth.reduce((sum, m) => sum + m.count, 0)

  return (
    <div className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 p-6">
      <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold mb-6">
        Member Growth {currentYear}
      </div>
      <div className="flex items-end gap-2 h-40 mb-4">
        {monthlyGrowth.map(({ month, count }) => (
          <div key={month} className="flex-1 flex flex-col items-center gap-1">
            {count > 0 && <div className="text-xs text-gray-500 font-mono">{count}</div>}
            <div
              className="w-full bg-green-600 transition-all"
              style={{ height: `${(count / maxValue) * 100}%`, minHeight: count > 0 ? '4px' : '0' }}
            />
            <div className="text-xs text-gray-500">{month}</div>
          </div>
        ))}
      </div>
      <div className="pt-4 border-t border-gray-200 dark:border-white/10 flex justify-between text-xs text-gray-500">
        <span>New members this year: <span className="text-green-500 dark:text-green-400 font-bold">{totalThisYear}</span></span>
        <span>Total members: <span className="text-gray-900 dark:text-white font-bold">{members.length}</span></span>
      </div>
    </div>
  )
}